/**
 * Fonte única de permissões (espelho de `projeto/js/core/Auth.js`).
 * Ao portar módulos na Fase 4, reutilize estas chaves — não invente MATRIX paralela.
 */
import type { MatrixRow, Perfil, PerfilMeta } from './types'

export const PERFIL_LABELS: Record<Perfil, PerfilMeta> = {
  admin: { label: 'Administrador', cor: '#7c3aed' },
  rh: { label: 'Gestor de RH', cor: '#2563eb' },
  gestor: { label: 'Gestor de Equipe', cor: '#16a34a' },
  analista: { label: 'Analista de RH', cor: '#0891b2' },
  colab: { label: 'Colaborador', cor: '#64748b' },
  juridico: { label: 'Jurídico', cor: '#b45309' },
}

export const MATRIX: Record<Perfil, MatrixRow> = {
  admin: {
    'command-center': 'edit',
    dashboard: 'edit',
    pessoas: 'edit',
    indicadores: 'edit',
    servicos: 'edit',
    comunicacao: 'edit',
    experiencia: 'edit',
    jornada: 'edit',
    endomarketing: 'edit',
    recrutamento: 'edit',
    departamento: 'edit',
    integracoes: 'edit',
    cargos: 'edit',
    empresas: 'edit',
    desenvolvimento: 'edit',
    clima: 'edit',
    documentos: 'edit',
    nr01: 'edit',
    ouvidoria: 'edit',
    gestor: 'edit',
    bonificacoes: 'edit',
    portal: 'edit',
    analytics: 'edit',
    timeline: 'edit',
    automacao: 'edit',
    dpc: 'edit',
    dpdashboard: 'edit',
    'dp-massa': 'edit',
    usuarios: 'edit',
    colaboradores: 'edit',
    ged: 'edit',
    'inteligencia-central': 'edit',
    'organograma-vivo': 'edit',
    'health-score': 'edit',
    engajamento: 'edit',
    'copiloto-ia': 'edit',
    'dashboard-adaptativo': 'edit',
    'mapa-energia': 'edit',
    'perfil-dna': 'edit',
    'hi-rede': 'edit',
    'rede-feed': 'edit',
    'rede-tv': 'edit',
    'rede-midia': 'edit',
    'tv-corporativa': 'edit',
    'plano-contratacao': 'edit',
    'plano-demissao': 'edit',
    relatorios: 'edit',
    pit: 'edit',
    'vibracao-corporativa': 'edit',
    'whatsapp-inbox': 'edit',
    'ia-rh': 'edit',
    'calendario-corporativo': 'edit',
    competencias: 'edit',
    'assinatura-digital': 'edit',
    'epi-fardamento': 'edit',
    'drive-corporativo': 'edit',
    'risco-trabalhista': 'edit',
    'laudo-tecnico': 'edit',
    'dp-admissao': 'edit',
    'dp-ferias': 'edit',
    'dp-rescisao': 'edit',
    'dp-beneficios': 'edit',
    'flow-intelligence': 'edit',
    'reunioes-lideranca': 'edit',
    'fluxos-operacionais': 'edit',
    'organograma-operacional': 'edit',
    'knowledge-base': 'edit',
    'onboarding-shadow': 'edit',
    'alertas-corporativos': 'edit',
    'central-integracao': 'edit',
    aniversariantes: 'edit',
    'dp-avaliacao-exp': 'edit',
    'central-desligamentos': 'edit',
    'dp-documentos': 'edit',
    'dp-workflow-folha': 'edit',
    'dp-ferias-enterprise': 'edit',
    workflows: 'edit',
  },
  rh: {
    dashboard: 'view',
    pessoas: 'edit',
    indicadores: 'view',
    servicos: 'edit',
    comunicacao: 'edit',
    experiencia: 'edit',
    jornada: 'view',
    endomarketing: 'edit',
    recrutamento: 'edit',
    departamento: 'edit',
    integracoes: false,
    cargos: 'edit',
    empresas: 'edit',
    desenvolvimento: 'edit',
    clima: 'edit',
    documentos: 'edit',
    nr01: 'edit',
    ouvidoria: 'edit',
    gestor: 'edit',
    bonificacoes: 'edit',
    portal: 'view',
    analytics: 'edit',
    timeline: 'edit',
    automacao: 'edit',
    dpc: 'edit',
    dpdashboard: 'edit',
    'dp-massa': 'edit',
    usuarios: false,
    colaboradores: 'edit',
    ged: 'edit',
    'inteligencia-central': 'view',
    'organograma-vivo': 'view',
    'health-score': 'view',
    engajamento: 'edit',
    'copiloto-ia': 'view',
    'dashboard-adaptativo': 'view',
    'mapa-energia': 'view',
    'perfil-dna': 'view',
    'hi-rede': 'edit',
    'rede-feed': 'edit',
    'rede-tv': 'edit',
    'rede-midia': 'edit',
    'tv-corporativa': 'edit',
    'plano-contratacao': 'edit',
    'plano-demissao': 'edit',
    relatorios: 'edit',
    pit: 'edit',
    'vibracao-corporativa': 'view',
    'whatsapp-inbox': 'edit',
    'ia-rh': 'edit',
    'calendario-corporativo': 'edit',
    competencias: 'edit',
    'assinatura-digital': 'edit',
    'epi-fardamento': 'edit',
    'drive-corporativo': 'edit',
    'risco-trabalhista': 'edit',
    'laudo-tecnico': 'edit',
    'dp-admissao': 'edit',
    'dp-ferias': 'edit',
    'dp-rescisao': 'edit',
    'dp-beneficios': 'edit',
    'flow-intelligence': 'edit',
    'reunioes-lideranca': 'edit',
    'fluxos-operacionais': 'edit',
    'organograma-operacional': 'edit',
    'knowledge-base': 'edit',
    'onboarding-shadow': 'edit',
    'alertas-corporativos': 'edit',
    'central-integracao': 'edit',
    aniversariantes: 'edit',
    'dp-avaliacao-exp': 'edit',
    'central-desligamentos': 'edit',
    'dp-documentos': 'edit',
    'dp-workflow-folha': 'edit',
    'dp-ferias-enterprise': 'edit',
    workflows: 'edit',
    'command-center': 'view',
  },
  gestor: {
    dashboard: 'view',
    pessoas: 'edit',
    indicadores: 'view',
    servicos: 'view',
    comunicacao: 'view',
    experiencia: 'view',
    jornada: 'view',
    endomarketing: false,
    recrutamento: 'view',
    departamento: false,
    integracoes: false,
    cargos: 'view',
    empresas: 'view',
    desenvolvimento: 'view',
    clima: 'view',
    documentos: 'view',
    nr01: 'view',
    ouvidoria: 'view',
    gestor: 'edit',
    bonificacoes: 'view',
    portal: 'view',
    analytics: 'view',
    timeline: 'view',
    automacao: false,
    dpc: false,
    dpdashboard: false,
    'dp-massa': false,
    usuarios: false,
    colaboradores: false,
    ged: false,
    'inteligencia-central': false,
    'organograma-vivo': 'view',
    'health-score': false,
    engajamento: 'view',
    'copiloto-ia': 'view',
    'dashboard-adaptativo': 'view',
    'mapa-energia': 'view',
    'perfil-dna': 'view',
    'hi-rede': 'view',
    'rede-feed': 'view',
    'rede-tv': 'view',
    'rede-midia': false,
    'tv-corporativa': 'view',
    'plano-contratacao': 'view',
    'plano-demissao': 'view',
    relatorios: 'view',
    pit: 'view',
    'vibracao-corporativa': 'edit',
    'ia-rh': 'view',
    'calendario-corporativo': 'view',
    competencias: 'view',
    'drive-corporativo': 'view',
    'risco-trabalhista': 'view',
    'epi-fardamento': 'view',
    'dp-admissao': false,
    'dp-ferias': false,
    'dp-rescisao': false,
    'dp-beneficios': false,
    'flow-intelligence': 'view',
    'reunioes-lideranca': 'edit',
    'fluxos-operacionais': false,
    'organograma-operacional': 'view',
    'knowledge-base': 'view',
    'onboarding-shadow': false,
    'alertas-corporativos': 'view',
    'central-integracao': 'view',
    aniversariantes: false,
    'dp-avaliacao-exp': 'edit',
    'central-desligamentos': 'view',
    'dp-documentos': false,
    'dp-workflow-folha': false,
    'dp-ferias-enterprise': false,
    workflows: 'view',
    'command-center': 'view',
  },
  analista: {
    dashboard: 'view',
    pessoas: 'edit',
    indicadores: false,
    servicos: 'view',
    comunicacao: 'edit',
    experiencia: 'edit',
    jornada: 'view',
    endomarketing: 'view',
    recrutamento: 'edit',
    departamento: 'edit',
    integracoes: false,
    cargos: 'view',
    empresas: 'view',
    desenvolvimento: 'edit',
    clima: 'view',
    documentos: 'edit',
    nr01: 'view',
    ouvidoria: 'edit',
    gestor: 'view',
    bonificacoes: 'edit',
    portal: 'view',
    analytics: false,
    timeline: false,
    automacao: false,
    dpc: false,
    dpdashboard: false,
    'dp-massa': false,
    usuarios: false,
    colaboradores: 'edit',
    ged: 'view',
    'inteligencia-central': false,
    'organograma-vivo': false,
    'health-score': false,
    engajamento: 'view',
    'copiloto-ia': false,
    'dashboard-adaptativo': 'view',
    'mapa-energia': false,
    'perfil-dna': 'view',
    'hi-rede': 'view',
    'rede-feed': 'view',
    'rede-tv': false,
    'rede-midia': false,
    'tv-corporativa': 'view',
    'plano-contratacao': 'edit',
    'plano-demissao': 'edit',
    relatorios: 'view',
    pit: 'view',
    'vibracao-corporativa': 'view',
    'ia-rh': 'view',
    'calendario-corporativo': 'edit',
    competencias: 'view',
    'assinatura-digital': 'view',
    'epi-fardamento': 'edit',
    'drive-corporativo': 'view',
    'risco-trabalhista': 'view',
    'laudo-tecnico': 'view',
    'dp-admissao': 'edit',
    'dp-ferias': 'edit',
    'dp-rescisao': 'edit',
    'dp-beneficios': 'edit',
    'flow-intelligence': 'view',
    'reunioes-lideranca': false,
    'fluxos-operacionais': 'view',
    'organograma-operacional': false,
    'knowledge-base': 'view',
    'onboarding-shadow': false,
    'alertas-corporativos': 'view',
    'central-integracao': 'edit',
    aniversariantes: 'edit',
    'dp-avaliacao-exp': 'edit',
    'central-desligamentos': 'edit',
    'dp-documentos': 'edit',
    'dp-workflow-folha': 'edit',
    'dp-ferias-enterprise': 'edit',
    workflows: 'edit',
    'command-center': 'view',
  },
  colab: {
    portal: 'view',
  },
  juridico: {
    dashboard: 'view',
    pessoas: 'view',
    indicadores: false,
    servicos: 'view',
    comunicacao: 'view',
    experiencia: false,
    jornada: false,
    endomarketing: false,
    recrutamento: false,
    departamento: 'view',
    integracoes: false,
    cargos: false,
    empresas: false,
    desenvolvimento: false,
    clima: false,
    documentos: 'edit',
    nr01: 'view',
    ouvidoria: 'edit',
    gestor: false,
    bonificacoes: false,
    portal: 'view',
    analytics: false,
    timeline: false,
    automacao: false,
    dpc: false,
    dpdashboard: false,
    'dp-massa': false,
    usuarios: false,
    colaboradores: false,
    ged: 'edit',
    'inteligencia-central': false,
    'organograma-vivo': false,
    'health-score': false,
    engajamento: false,
    'copiloto-ia': false,
    'dashboard-adaptativo': false,
    'mapa-energia': false,
    'perfil-dna': false,
    'hi-rede': false,
    'rede-feed': false,
    'rede-tv': false,
    'rede-midia': false,
    'plano-contratacao': false,
    'plano-demissao': 'view',
    relatorios: false,
    pit: false,
    'vibracao-corporativa': false,
    'ia-rh': false,
    'assinatura-digital': 'view',
    'risco-trabalhista': 'view',
    'laudo-tecnico': 'view',
    'drive-corporativo': 'view',
    'dp-beneficios': false,
    'dp-admissao': false,
    'dp-ferias': false,
    'dp-rescisao': false,
    'flow-intelligence': false,
    'reunioes-lideranca': false,
    'fluxos-operacionais': false,
    'organograma-operacional': false,
    'knowledge-base': false,
    'onboarding-shadow': false,
    'central-integracao': false,
    aniversariantes: false,
    'dp-avaliacao-exp': false,
    'central-desligamentos': 'view',
    'dp-documentos': 'view',
    'dp-workflow-folha': false,
    'dp-ferias-enterprise': false,
  },
}

/** Páginas do sidebar legado (referência; nav React usa APP_NAV filtrado por MATRIX). */
export const SIDEBAR_PAGES: Record<Perfil, string[]> = {
  admin: [
    'command-center',
    'portal',
    'alertas-corporativos',
    'colaboradores',
    'timeline',
    'perfil-dna',
    'aniversariantes',
    'cargos',
    'empresas',
    'organograma-vivo',
    'competencias',
    'central-integracao',
    'plano-contratacao',
    'desenvolvimento',
    'documentos',
    'ouvidoria',
    'knowledge-base',
    'dpc',
    'departamento',
    'dp-ferias',
    'dp-rescisao',
    'dp-beneficios',
    'dp-avaliacao-exp',
    'nr01',
    'risco-trabalhista',
    'epi-fardamento',
    'laudo-tecnico',
    'recrutamento',
    'gestor',
    'reunioes-lideranca',
    'calendario-corporativo',
    'indicadores',
    'ia-rh',
    'automacao',
    'onboarding-shadow',
    'fluxos-operacionais',
    'workflows',
    'dp-massa',
    'rede-feed',
    'tv-corporativa',
    'vibracao-corporativa',
    'whatsapp-inbox',
    'relatorios',
    'usuarios',
    'integracoes',
  ],
  rh: [
    'command-center',
    'portal',
    'alertas-corporativos',
    'colaboradores',
    'timeline',
    'perfil-dna',
    'aniversariantes',
    'cargos',
    'empresas',
    'organograma-vivo',
    'competencias',
    'central-integracao',
    'plano-contratacao',
    'desenvolvimento',
    'documentos',
    'ouvidoria',
    'knowledge-base',
    'dpc',
    'departamento',
    'dp-ferias',
    'dp-rescisao',
    'dp-beneficios',
    'dp-avaliacao-exp',
    'nr01',
    'risco-trabalhista',
    'epi-fardamento',
    'laudo-tecnico',
    'recrutamento',
    'gestor',
    'reunioes-lideranca',
    'calendario-corporativo',
    'indicadores',
    'ia-rh',
    'automacao',
    'onboarding-shadow',
    'fluxos-operacionais',
    'workflows',
    'dp-massa',
    'rede-feed',
    'tv-corporativa',
    'vibracao-corporativa',
    'whatsapp-inbox',
    'relatorios',
  ],
  gestor: [
    'command-center',
    'portal',
    'alertas-corporativos',
    'timeline',
    'perfil-dna',
    'cargos',
    'empresas',
    'organograma-vivo',
    'competencias',
    'central-integracao',
    'plano-contratacao',
    'desenvolvimento',
    'documentos',
    'ouvidoria',
    'knowledge-base',
    'dp-avaliacao-exp',
    'nr01',
    'gestor',
    'reunioes-lideranca',
    'calendario-corporativo',
    'indicadores',
    'ia-rh',
    'onboarding-shadow',
    'workflows',
    'rede-feed',
    'tv-corporativa',
    'vibracao-corporativa',
    'relatorios',
  ],
  analista: [
    'command-center',
    'portal',
    'alertas-corporativos',
    'colaboradores',
    'perfil-dna',
    'aniversariantes',
    'cargos',
    'empresas',
    'competencias',
    'central-integracao',
    'plano-contratacao',
    'desenvolvimento',
    'documentos',
    'ouvidoria',
    'knowledge-base',
    'departamento',
    'dp-ferias',
    'dp-rescisao',
    'dp-beneficios',
    'dp-avaliacao-exp',
    'nr01',
    'risco-trabalhista',
    'epi-fardamento',
    'laudo-tecnico',
    'recrutamento',
    'calendario-corporativo',
    'indicadores',
    'ia-rh',
    'fluxos-operacionais',
    'workflows',
    'rede-feed',
    'relatorios',
  ],
  colab: ['portal'],
  juridico: [
    'portal',
    'documentos',
    'ouvidoria',
    'departamento',
    'dp-rescisao',
    'nr01',
    'risco-trabalhista',
    'laudo-tecnico',
  ],
}
